export default __webpack_public_path__ + "static/media/grs.e1db914a.svg";